import { Trans } from '@lingui/macro';
import * as React from 'react';

export const inputHasAtLeatOneSpecialCharErrorMessage = (
  <Trans>
    Ce champ doit contenir un caractère spécial
  </Trans>
);
